import React from "react";
import HambergerBtn from "./HambergerBtn";
import LogoBirVpn from "./LogoBirVpn";
import NavbarCollaps from "./NavbarCollaps";

export default function NavBar() {
  return (
    <nav className="p-3 navbar  border-start-0 border-end-0 border-top-0 navbar-expand-lg custoom-navv">
      <div className="container-fluid">
        <LogoBirVpn />
        <HambergerBtn />
        <NavbarCollaps />
      </div>
    </nav>
  );
}
